export default __webpack_public_path__ + "static/media/Naim-redShirt.8389eb17.jpg";